import ContactUs1 from "./ContactUs1.js";
import ContactUs2 from "./ContactUs2.js";
import ContactUs3 from "./ContactUs3.js";

const componentsArray = [ContactUs1, ContactUs2, ContactUs3];
export default componentsArray;
